/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_SupportInputs */

const en_common_support = /** @type {(inputs: Common_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Support`)
};

const es_common_support = /** @type {(inputs: Common_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soporte`)
};

/**
* | output |
* | --- |
* | "Support" |
*
* @param {Common_SupportInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_support = /** @type {((inputs?: Common_SupportInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_SupportInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_support(inputs)
	return en_common_support(inputs)
});